import { createClient } from '@supabase/supabase-js'

type PublicConfig = {
  supabaseUrl?: string
  supabasePublishableKey?: string
}

async function resolvePublicConfig(): Promise<Required<PublicConfig>> {
  const localConfig: PublicConfig = {
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL?.trim(),
    supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim(),
  }

  if (localConfig.supabaseUrl && localConfig.supabasePublishableKey) {
    return localConfig as Required<PublicConfig>
  }

  const response = await fetch('/api/config', { headers: { Accept: 'application/json' } })
  if (!response.ok) throw new Error('Unable to load public application configuration.')

  const runtimeConfig = (await response.json()) as PublicConfig
  const supabaseUrl = runtimeConfig.supabaseUrl?.trim()
  const supabasePublishableKey = runtimeConfig.supabasePublishableKey?.trim()

  if (!supabaseUrl || !supabasePublishableKey) {
    throw new Error('Missing Supabase runtime configuration.')
  }

  return { supabaseUrl, supabasePublishableKey }
}

const { supabaseUrl, supabasePublishableKey } = await resolvePublicConfig()

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
